import React from 'react';
import {connect} from "react-redux";
import{Step,
    Stepper,
    StepButton,
    StepContent,
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import CustomPaper from './../../shared/utils/CustomPaper';
import config from './../../../config';
import {Link} from 'react-router-dom'
import CustomAppBarPublic from "../utils/CustomAppBarPublic";



class RecupMotDePasse extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            stepIndex: 0,
            email:'',
            code_reset:'',
            mdp_1:'',
            mdp_2:'',
            emailErrorText:'',
            code_resetErrorText:'',
            mdpErrorText:'',
            userType:''
        };
        window.scrollTo(0, 0);
    }



    handleNext = () => {
        const {stepIndex} = this.state;
        if(stepIndex === 0) {
            axios.post(config.ws_path+'/public/get_code_reset',{email:this.state.email})
                .then( x => this.setState({stepIndex: stepIndex + 1, emailErrorText:'', userType:x.data.userType}))
                .catch( error => this.setState({emailErrorText: error.response.data.status}));
        }
        else if(stepIndex === 1){
            this.setState({stepIndex: 2})
        }else if(stepIndex === 2){
            axios.post(config.ws_path+'/public/password',this.state)
                .then( x => this.setState({stepIndex:3}))
                .catch( error => console.log(error.response.data));
        }

    };

    handlePrev = () => {
        const {stepIndex} = this.state;
        if (stepIndex > 0) {
            this.setState({stepIndex: stepIndex - 1});
        }
    };

    handleChange = (event, value) =>{
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }


    renderStepActions(step) {
        return (
            <div style={{margin: '12px 0'}}>
                {<RaisedButton
                    label={step === 2 ? "Valider" : "Suivant"}
                    disableTouchRipple={true}
                    disableFocusRipple={true}
                    disabled={
                            step === 0 ?
                                this.state.email.trim().length < 3
                                || this.state.email.trim().indexOf('@') === -1

                                :step === 1 ?
                                this.state.code_reset.length < 5

                                :step === 2 ?

                                    this.state.mdp_1 !== this.state.mdp_2
                                    || this.state.mdp_1.length < 8
                                    :true
                    }
                    primary={true}
                    onClick={this.handleNext}
                    style={{marginRight: 12}}
                />}
                {step > 0 && (
                    <FlatButton
                        label="Précédent"
                        disableTouchRipple={true}
                        disableFocusRipple={true}
                        onClick={this.handlePrev}
                    />
                )}
            </div>
        );
    }



    render() {
        const {stepIndex} = this.state;

        return (
            <div>
                <CustomAppBarPublic/>
                <div className='row justify-content-md-center'>
                    <div className='col-12 col-md-6'>
                        <CustomPaper title='Récupération de mot de passe'>
                            <div style={{maxWidth: 800, minHeight: 700, margin: 'auto'}}>
                                <Stepper
                                    activeStep={stepIndex}
                                    linear={false}
                                    orientation="vertical"
                                >
                                    <Step>
                                        <StepButton>Adresse mail</StepButton>
                                        <StepContent>
                                            <p>Veuillez renseigner l'adresse email utilisée par vous ou par votre employeur pour la création de votre compte monEntretienPRO.</p>
                                            <TextField
                                                floatingLabelText="Votre Email"
                                                name='email'
                                                type='email'
                                                value={this.state.email}
                                                onChange={this.handleChange}
                                                errorText={this.state.emailErrorText}
                                            /><br />
                                            {this.renderStepActions(0)}
                                        </StepContent>
                                    </Step>
                                    <Step>
                                        <StepButton>Code d'accès</StepButton>
                                        <StepContent>
                                            <p>Nous venons de vous envoyer un email avec un code de réinitialisation.</p>
                                            <p>Veuillez sésir le code ici.</p>
                                            <TextField
                                                floatingLabelText="Code"
                                                name='code_reset'
                                                type='text'
                                                value={this.state.code_reset}
                                                onChange={this.handleChange}
                                                errorText={this.state.code_resetErrorText}
                                            /><br />
                                            {this.renderStepActions(1)}
                                        </StepContent>
                                    </Step>
                                    <Step>
                                        <StepButton>Nouveau mot de passe</StepButton>
                                        <StepContent>
                                            <p>Veuillez saisir votre nouveau mot de passe.</p>
                                            <TextField
                                                floatingLabelText="Mot de passe"
                                                name='mdp_1'
                                                value={this.state.mdp_1}
                                                onChange={this.handleChange}
                                                type='password'
                                                errorText={this.state.mdpErrorText}
                                            /><br />
                                            <TextField
                                                floatingLabelText="Resaisissez le mot de passe"
                                                name='mdp_2'
                                                type='password'
                                                value={this.state.mdp_2}
                                                onChange={this.handleChange}
                                                errorText={this.state.mdpErrorText}
                                            /><br />
                                            {this.renderStepActions(2)}
                                        </StepContent>
                                    </Step>
                                    <Step>
                                        <StepButton>Connexion</StepButton>
                                        <StepContent>
                                            <p>La modification de votre mot de passe est réussie.</p>
                                            <p>Veuillez <Link to={'/'}> cliquer ici</Link> pour vous connecter.</p>
                                        </StepContent>
                                    </Step>
                                </Stepper>
                            </div>
                        </CustomPaper>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {open: store.shared.drawer.open}
}

export default connect(mapStateToProps)(RecupMotDePasse);


// WEBPACK FOOTER //
// ./src/components/shared/pages/RecupMotDePasse.js